// extracted by mini-css-extract-plugin
module.exports = {"Copyright":"Copyright_Copyright__2prW0","Bolded":"Copyright_Bolded___zDhP"};